import { Injectable } from '@angular/core';
import { Localidad, Provincia, TipoDocumento, TipoVia } from '../../model/poliza.model';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';
import { SegurosApiService } from '../api/seguros-api.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogoGeneralStoreService {
  private tiposDocumento: TipoDocumento[]

  private tiposVia: TipoVia[];

  private provincias: Provincia[];

  constructor(private segurosService: SegurosApiService) { }

  getTiposDocumento(): Observable<TipoDocumento[]> {
    if (this.tiposDocumento) {
      return of(this.tiposDocumento); // devuelve desde caché
    } else {
      return this.segurosService.getTiposDocumento().pipe(
        tap(data => this.tiposDocumento = data) // guarda en caché
      );
    }
  }

  getTiposVia(): Observable<TipoVia[]> {
    if(this.tiposVia){
      return of(this.tiposVia); // devuelve desde caché
    } else {
      return this.segurosService.getTiposVia().pipe(
        tap(data => this.tiposVia = data) // guarda en caché
      );
    }
  }

  getProvincias(): Observable<Provincia[]> {
    if (this.provincias) {
      return of(this.provincias); // devuelve desde caché
    } else {
      return this.segurosService.getProvincias().pipe(
        tap(data => this.provincias = data) // guarda en caché
      );
    }
  }

  getLocalidadesPorCP(codPostal: string) {
    return this.segurosService.getLocalidadesPorCP(codPostal).pipe(
      catchError((err) => {
        console.error('Error fetching localidades:', err);
        return of([]);
      })
    );
  }

  getIdTipoDocumento(documento: string): Observable<number> {
    return this.segurosService.getIdTipoDocumento(documento).pipe(
      catchError((err) => {
        console.error('Error fetching tipo documento detectado:', err);
        return of(-1);
      })
    );
  }

  getTipoDocumento(documento: string): Observable<TipoDocumento> {
    return this.segurosService.getTipoDocumento(documento).pipe(
      catchError((err) => {
        console.error('Error fetching tipo documento detectado:', err);
        return of({} as TipoDocumento);
      })
    );
  }

}
